/* src/app/container/pages/containers-new/containers-new.component.scss */
/*# sourceMappingURL=containers-new.component.css.map */
